import React, {Component} from 'react';
import Map from '../Map'
import {unauthApiUrl, googleMapUrl} from "../../../Shared/api";
import axios from "axios";
import Dropdown from '../Dropdown';
import County from '../County';

export default class App extends Component {
    static defaultProps = {
        zoom: 6,
        city: 'ATH',
        location: {lat: 37.983810, lng: 23.727539},
        manufacturer: 0,
        service: '000'
    };

    constructor(props) {
        super(props);
        this._map = {};
        this.state = {
            zoom: App.defaultProps.zoom,
            partners: [],
            show: false,
            currentPartner: null,
            currentCity: null,
            currentService: App.defaultProps.service,
            services: [
                {value: App.defaultProps.service, label: "Όλες οι υπηρεσίες"},
                {value: '002', label: 'Υπηρεσία Συντήρησης Λέβητα Φυσικού Αερίου'},
                {value: '001', label: 'Υπηρεσία Energy Check up'}
            ],
            cities: [
                {value: 'ATH', label: 'N. Αττικής', location: {lat: 37.9908359, lng: 23.7208298}, type: 'N', zoom: 11},
                {value: 'SKG', label: 'N. Θεσσαλονίκης', location: {lat: 40.6211912, lng: 22.9285177}, type: 'N', zoom: 11},
                {value: 'KRD', label: 'Ν. Καρδίτσας', location: {lat: 39.364709, lng: 21.9109164}, type: 'N', zoom: 12},
                {value: 'LAR', label: 'Ν. Λάρισας', location: {lat: 39.6310074, lng: 22.4066366}, type: 'N', zoom: 12},
                {value: 'MAG', label: 'Ν. Μαγνησίας', location: {lat: 39.301387, lng: 22.9594523}, type: 'N', zoom: 11},
                {value: 'TRK', label: 'Ν. Τρικάλων', location: {lat: 39.553431, lng: 21.7555493}, type: 'N', zoom: 12},
                {value: 'PMT', label: 'Π. Ανατολικής Μακεδονίας και Θράκης', location: {lat: 41.138503, lng: 25.130710}, type: 'P', zoom: 9},
                {value: 'ATT', label: 'Π. Αττικής', location: {lat: 37.920297, lng: 23.779977}, type: 'P', zoom: 10},
                {value: 'BAG', label: 'Π. Βόρειου Αιγαίου', location: {lat: 39.451207, lng: 25.1161213}, type: 'P', zoom: 8},
                {value: 'DEL', label: 'Π. Δυτικής Ελλάδας', location: {lat: 38.247477, lng: 21.767948}, type: 'P', zoom: 9},
                {value: 'DMA', label: 'Π. Δυτικής Μακεδονίας', location: {lat: 40.400232, lng: 21.487966}, type: 'P', zoom: 9},
                {value: 'HPR', label: 'Π. Ηπείρου', location: {lat: 39.678697, lng: 20.771719}, type: 'P', zoom: 9},
                {value: 'THE', label: 'Π. Θεσσαλίας', location: {lat: 39.584382, lng: 22.221067}, type: 'P', zoom: 9},
                {value: 'ION', label: 'Π. Ιόνιων Νήσων', location: {lat: 38.686357, lng: 20.381241}, type: 'P', zoom: 8},
                {value: 'KMG', label: 'Π. Κεντρικής Μακεδονίας', location: {lat: 40.588577, lng: 23.2367873}, type: 'P', zoom: 9},
                {value: 'CRT', label: 'Π. Κρήτης', location: {lat: 35.207217, lng: 24.834616}, type: 'P', zoom: 9},
                {value: 'NAG', label: 'Π. Νότιου Αιγαίου', location: {lat: 36.79107, lng: 26.262680}, type: 'P', zoom: 8},
                {value: 'PEL', label: 'Π. Πελοποννήσου', location: {lat: 37.446735, lng: 22.422433}, type: 'P', zoom: 9},
                {value: 'STE', label: 'Π. Στερεάς Ελλάδας', location: {lat: 38.739429, lng: 23.1326843}, type: 'P', zoom: 9},
            ],
            currentManufacturer: App.defaultProps.manufacturer,
            manufacturers: [{value: App.defaultProps.manufacturer, label: "Όλοι οι κατασκευαστές"}],
        }
    }

    onPartnerClick = (idx) => {
        this.setState({currentPartner: idx});
    };

    onPartnerInfoCloseClick = () => {
        this.setState({currentPartner: null});
    };

    onServiceClick = ({item, isChecked}) => {
        this.setState((prevState) => {
            const services = prevState.services.map(service =>
                service.type === item
                    ? Object.assign(service, {isChecked})
                    : service
            );
            return {
                services,
            }
        })
    };

    getPartners = () => {
        axios.get(
            unauthApiUrl('partners'))
            .then((response) => {
                this.setState({
                    partners: response.data.partners.map((partner) =>
                        Object.assign(partner, {isSelected: false})),
                    show: true
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getManufacturers = () => {
        axios.get(
            unauthApiUrl('partners/manufacturers'))
            .then((response) => {
                this.setState((prevState) => {
                    return ({
                        manufacturers: [...response.data
                            .reduce((acc, manufacturer) =>
                                    acc.concat({value: manufacturer.id, label: manufacturer.name})
                                , prevState.manufacturers)
                            , {value: 999, label: "Άλλος Κατασκευαστής"}
                        ]
                    })
                })
            })
            .catch((error) => {
                console.log(error);
            });
    };

    onCityClick = (currentCity) => {
        const {cities} = this.state;
        const {zoom} = cities.find(city => city.value === currentCity);
        this.setState({currentCity, zoom});
    };

    onManufacturerChange = (manufacturer) => {
        this.setState({currentManufacturer: manufacturer});
    };

    onServiceChange = (service) => {
        this.setState({
            currentService: service,
            currentManufacturer: App.defaultProps.manufacturer,
        });
    };

    handleMapLoad = (map) => {
        this._map = map;
    };

    componentDidMount() {
        this.getPartners();
        this.getManufacturers();
    }

    render() {
        const {
            partners, currentPartner, services, cities, currentService,
            currentCity, currentManufacturer, manufacturers, zoom
        } = this.state;

        const city = cities.find(city => city.value === currentCity);
        const manufacturer = manufacturers.find(manufacturer => manufacturer.value === currentManufacturer);
        const service = services.find(service => service.value === currentService);

        const availablePartners = partners
            .filter(partner =>
                service.value === App.defaultProps.service ||
                partner.services.some(ps =>
                    ps.code === service.value
                )
            )
            .filter(partner =>
                manufacturer.value === App.defaultProps.manufacturer ||
                partner.allManufacturers ||
                partner.manufacturers.some(pm =>
                    pm.manufacturerId === manufacturer.value
                )
            );
        return (
            <div className={"map"}>
                <div className="criteria">
                    <div>
                        <span className={"title"}>Επιλέξτε Περιοχή</span>
                        <County
                            name={"cities"}
                            id={"cities-simple"}
                            label={"Νομός"}
                            options={cities}
                            onChange={this.onCityClick}
                            value={city ? city.value : ""}
                        />

                    </div>
                    <div>
                        <span className={"title"}>Επιλέξτε υπηρεσία</span>
                        <Dropdown
                            name={"services"}
                            id={"services-simple"}
                            label={"Υπηρεσίες"}
                            options={services}
                            onChange={this.onServiceChange}
                            value={service.value}
                        />
                    </div>
                    {service.value === '002'
                        ? (
                            <div>
                                <span className={"title"}>Επιλέξτε τύπο συσκευής</span>
                                <Dropdown
                                    name={"manufacturers"}
                                    id={"manufacturers-simple"}
                                    label={"Κατασκευαστές"}
                                    options={manufacturers}
                                    onChange={this.onManufacturerChange}
                                    value={manufacturer.value}
                                />
                            </div>)
                        : null}
                </div>
                <Map
                    isMarkerShown={false}
                    onMapLoad={this.handleMapLoad}
                    zoom={zoom}
                    center={city ? city.location : App.defaultProps.location}
                    partners={availablePartners}
                    currentPartner={currentPartner}
                    onMarkerClick={this.onPartnerClick}
                    onInfoWindowClose={this.onPartnerInfoCloseClick}
                    googleMapURL={googleMapUrl()}
                    containerElement={<div className={"mapContainer"}/>}
                    mapElement={<div className={"mapElement"}/>}
                    loadingElement={<div>Loading...</div>}
                />
            </div>
        )
    }
}